<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_i"></a><img alt="" src="images/i.jpg"/></h1>
<p class="publisher"><span>The Bathroom Readers’ Institute</span></p>
<p class="publisher1"><span>San Diego, California</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4ab9b22c